import { defineMessages } from 'react-intl';

export const messages: {
	confluence: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	invitedLozenge: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jira: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jsm: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loom: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	popupAcceptInviteButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	popupCollaboratorsTooltip: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	popupLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	popupLoadingLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	popupMainTextWithCollaborators: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	popupMainTextWithoutCollaborators: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	invitedLozenge: {
		id: 'cross-join-nudges.invited-app-shortcuts.invited-lozenge',
		defaultMessage: 'Invited',
		description:
			'A lozenge shown next to the sidebar shorcut apps the user has been invited to but has not yet accessed.',
	},
	popupMainTextWithCollaborators: {
		id: 'cross-join-nudges.invited-app-shortcuts.popup-main-text-with-collaborators',
		defaultMessage: "You're invited to join your team",
		description:
			'The main copy of the popup shown when the user hovers an invited app shorcut in the sidebar, if the user has collaborators.',
	},
	popupMainTextWithoutCollaborators: {
		id: 'cross-join-nudges.invited-app-shortcuts.popup-main-text-without-collaborators',
		defaultMessage: "Don't lose access, accept invite now",
		description:
			'The main copy of the popup shown when the user hovers an invited app shorcut in the sidebar, if the user does not have collaborators.',
	},
	popupAcceptInviteButton: {
		id: 'cross-join-nudges.invited-app-shortcuts.popup-accept-invite-button',
		defaultMessage: 'Accept invite',
		description:
			'Link button text in the popup shown when the user hovers an invited app shorcut in the sidebar. When clicked, the user will go to the app.',
	},
	popupCollaboratorsTooltip: {
		id: 'cross-join-nudges.invited-app-shortcuts.popup-collaborators-tooltip',
		defaultMessage:
			'{numberOfCollaborators} more {numberOfCollaborators, plural, one {teammate} other {teammates}} are using {app}',
		description:
			'Tooltip text for the more indicator in the popup shown when the user hovers an invited app shorcut in the sidebar, if the user has collaborators.',
	},
	popupLoadingLabel: {
		id: 'cross-join-nudges.common.invited-app-shortcuts.popup-loading-label',
		defaultMessage: 'Loading invite details',
		description:
			'Accessible label for the invited app shortcut popup while its contents are loading.',
	},
	popupLabel: {
		id: 'cross-join-nudges.common.invited-app-shortcuts.popup-label',
		defaultMessage: 'The details of your invite',
		description:
			'Accessible label for the invited app shortcut popup after its contents have loaded.',
	},
	jira: {
		id: 'cross-join-nudges.invited-app-shortcuts.jira',
		defaultMessage: 'Jira',
		description: 'The name of the Jira product app shortcut in the sidebar.',
	},
	confluence: {
		id: 'cross-join-nudges.invited-app-shortcuts.confluence',
		defaultMessage: 'Confluence',
		description: 'The name of the Confluence app.',
	},
	jsm: {
		id: 'cross-join-nudges.invited-app-shortcuts.jsm',
		defaultMessage: 'Jira Service Management',
		description: 'The name of the JSM app shown in the collaborators tooltip.',
	},
	loom: {
		id: 'cross-join-nudges.invited-app-shortcuts.loom',
		defaultMessage: 'Loom',
		description: 'The name of the Loom app shown in the collaborators tooltip.',
	},
});
